




























import { UwInput } from '@ultraware/vee-form-handler'
import { QBtn, QDate, QIcon, QPopupProxy } from 'quasar'
import { ValidationObserver } from 'vee-validate'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { isoDateOnlyFormat, transformDates, userDateFormat } from '@/domains/date'
import DateInput from '@/components/DateInput.vue'

@Component({
  components: {
    QBtn,
    QDate,
    QIcon,
    QPopupProxy,
    UwInput,
    ValidationObserver,
    DateInput,
  },
})

export default class SelectDateRange extends Vue {
  @Prop({ type: String, required: true }) public startDate!: string
  @Prop({ type: String, required: true }) public endDate!: string
  @Prop({ type: Boolean, default: false }) public resetButton!: boolean
  @Prop({ type: Boolean, default: false }) public validateStartDate!: boolean
  @Prop({ type: Boolean, default: false }) public validateEndDate!: boolean

  get fromDate(): string {
    return this.startDate
  }

  set fromDate(v: string) {
    this.$emit('update:startDate', v)
  }

  get toDate(): string {
    return this.endDate
  }

  set toDate(v: string) {
    this.$emit('update:endDate', v)
  }

  public resetDateRange(): void {
    this.fromDate = ''
    this.toDate = ''
  }

  public options(): (_: string) => boolean {
    return (d: string): boolean => new Date(transformDates(d, userDateFormat, isoDateOnlyFormat)) <= new Date()
  }

  get isEmpty(): boolean {
    return this.startDate === '' && this.endDate === ''
  }
}
